export default import.meta.ROLLUP_FILE_URL_DF4ySFeVk_oOMJNeRwxtqQ